import DetailsPageHeader from '../../components/DetailsPageHeader';
import { ReactComponent as MultiFileIcon} from '../../components/svgs/multiFileIcon.svg';
import OwnerSidebar from '../../components/owner/OwnerSidebar';


  

const OwnerInvoicingDetailsScreen = () => {


  return (
    <>
        <section className='dashboard-container flex '>
        <aside className=''>
        <OwnerSidebar/>
        </aside>
        <main className='main-container mb-32'>
            <DetailsPageHeader pageName={'invoices'} customerDetails={'invoice #108'} showButton={false}/>
            <section className='mt-10 flex gap-5 laundry-details-title-section'>
                <div className='laundry-details-title-container'>
                    <div className='laundry-details-title-items gap-10'>
                        <div className='multi-file-icon-border'>
                            <MultiFileIcon className='ml-5 mt-5'/>
                        </div>
                        <div className='flex flex-col'>
                            <p className='order-id'>Invoice #108</p>
                            <div className='invoicing-payment-status-border'>
                                <p className='order-status partial-payment'>Partial Payment</p>
                            </div>
                            
                        </div>
                        <section className='order-details-more-options'>
                                <div className='order-status-option-dropdown'>
                                    
                                    <select className='details-dropdown'>
                                        <option>More options</option>
                                        <option value="option1">Preview Invoice</option>
                                        <option value="option2">Set reminder</option>
                                        <option value="option3">Duplicate invoice</option>
                                        <option value="option4">Archive Invoice</option>
                                        {/* <option value="option3">Laundry Works</option> */}
                                    </select>
                                
                                </div>
                        </section>
                        
                    </div>
                    
                </div>
                <div>
                <div className='flex gap-96 p-6'>
                    <div className='flex flex-col gap-4'>
                        <p className='order-summary-title'>Customer</p>
                        <div className='flex gap-4'>
                            <div className='company-initials mt-4'>
                                <p className='company-initials-text'>GI</p>
                            </div>
                            <div className='flex flex-col'>
                                <p className='company-name'>Geller Industries</p>
                                <p className='company-rep'>Monica Geller</p>
                            </div>
                        </div>
                    </div>
                  
                    <div className='flex flex-col gap-4'>
                        <p className='order-summary-title'>Due date</p>
                        <p className='total-price'>31/12/23</p>
                        
                    </div>
                   
                    <div className='flex flex-col gap-4'>
                        <p className='order-summary-title'>Creation date</p>
                        <p className='total-price'>12/11/23</p>
                        
                    </div>
                </div>
                </div>
            </section>
            <section className='mt-20 gap-4 invoices-details'>
                <section>
                    <p className='details-title ml-6'>More details</p>
                    <div className='invoicing-details-divider mt-6'></div>
                </section>
                
               
                <section className='flex '>
                    <section className='flex flex-col order-details-section-container'>
                        <section className='flex flex-col gap-20'>
                            <div className='flex flex-col gap-4'>
                                <p className='details-title'>Associated Order(s)</p>
                                <p className='detail-subtitle'>Order #108</p>
                            </div>
                            <section className='flex gap-72'>
                                <div className='flex flex-col'>
                                    <p className='details-title'>No of bags</p>
                                    <p className='detail-subtitle'>3</p>
                                </div>
                                <div className='flex flex-col'>
                                    <p className='details-title'>Size</p>
                                    <p className='detail-subtitle'>75lbs</p>
                                </div>
                            </section>
                            
                            
                        </section>
                        <div className='order-details-divider'></div>
                        <section className='flex gap-56'>
                                <div className='flex flex-col gap-6'>
                                    <p className='details-title'>Billing frequency</p>
                                    <p className='detail-subtitle'>Per order</p>
                                </div>
                                <div className='flex flex-col gap-6'>
                                    <p className='details-title'>Payment preference</p>
                                    <p className='detail-subtitle'>On completion</p>
                                </div>
                            </section>
                    </section>
                    <section className='flex gap-96 pl-10 mt-10'>
                        <div className='flex flex-col gap-10'>
                            <p className='payment-summary-title'>Amount due</p>
                            <p className='payment-summary-title'>Amount Paid</p>
                            <p className='payment-summary-title'>Outstanding</p>
                        </div>
                        <div className='flex flex-col gap-10'>
                            <p className='payment-summary-subtitle'>$ 40.00</p>
                            <p className='payment-summary-subtitle'>$ 25.00</p>
                            <p className='payment-summary-subtitle'>$ 14.00</p>
                        </div>
                    </section>
                </section>
            </section>
        </main>
      </section>
    </>
  )
}

export default OwnerInvoicingDetailsScreen